/* eslint-disable @next/next/no-img-element */
"use client";
import SchedulesPa from "@/components/SchedulesPa";
import styles from "./styles.module.scss";
import Image from "next/image";
import PetAnjoSvg from "public/img/logo-pet-anjo.svg";
import SPetSvg from "public/img/logo-s-pet.svg";
import { ComponentInfosLojaSchedulesInput } from "@/graphql/generated/graphql";
import { ServiceProps } from "@/types/services";

export type ServicesProps = {
  isPetanjo: boolean;
  schedulesVet?: ComponentInfosLojaSchedulesInput;
  schedulesServices?: ComponentInfosLojaSchedulesInput;
  servicos: ServiceProps[];
  phoneServices?: string;
  descriptionServices?: string;
  onlineSchedule: boolean;
};

const Services = ({
  isPetanjo,
  schedulesVet,
  schedulesServices,
  servicos,
  phoneServices,
  descriptionServices,
  onlineSchedule
}: ServicesProps) => {
  return (
    <section className={styles.wrapper}>
      <div>
        {isPetanjo ? (
          <Image alt="Pet Anjo logo" src={PetAnjoSvg} height={40} />
        ) : (
          <Image alt="SPet" src={SPetSvg} height={40} />
        )}

        <p className="body-text-md pa-description">{descriptionServices}</p>

        <h2 className="subtitle-lg">Serviços disponíveis nesta loja:</h2>
        <div className={styles.flexRow}>
          {servicos.map((service, key) => (
            <div className={styles.cardItem} key={key}>
              <img
                alt="SPet"
                src={service.photo.url}
                height={122}
                width={172}
              />
              <div>
                <h3 className="subtitle-md">{service.name}</h3>
                <p className="body-text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <SchedulesPa
          schedulesVet={schedulesVet}
          schedulesServices={schedulesServices}
          phoneServices={phoneServices}
          onlineSchedule={onlineSchedule}
        />
      </div>
    </section>
  );
};

export default Services;
